var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.poi && _vm.settings)?_c('li',{staticClass:"cx-list__item"},[_c('a',{staticClass:"cx-link",on:{"click":_vm.openAccessibility}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('accessibility.barrierFreeTravelGuide') || 'barrierFreeTravelGuide'))])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cx-link__icon"},[_c('i',{staticClass:"fal fa-wheelchair"})])
}]

export { render, staticRenderFns }